import { modalConfirmAtom } from "atoms/app.atom"
import { type ClassValue, clsx } from "clsx"
import { isAldeia } from "hooks/useAldeia"
import { storeJotai } from "main"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function runWorker<TInput, TContext, TResult>(workerFactory: () => Worker, data: TInput, context?: TContext): Promise<TResult> {
  return new Promise((resolve, reject) => {
    const worker = workerFactory() // Inicializa o Worker a partir da fábrica fornecida

    // Escuta a resposta do Worker
    worker.onmessage = (event) => {
      resolve(event.data as TResult) // Resolve a Promise com o resultado do Worker
      worker.terminate() // Finaliza o Worker
    }

    // Escuta erros no Worker
    worker.onerror = (error) => {
      reject(error) // Rejeita a Promise em caso de erro
      worker.terminate() // Finaliza o Worker
    }

    // Envia os dados para o Worker
    worker.postMessage({
      data,
      context: Object.entries(context || {}).reduce((acc, [key, value]) => ({ ...acc, [key]: value?.toString() }), {}),
    })
  })
}

export function showDeleteModalConfirm(props: {
  description: string | React.ReactNode
  onConfirm: (...args: any[]) => any
  onCancel?: (...args: any[]) => any
  okText?: string
  cancelText?: string
  title?: string
  zIndex?: number
}) {
  if (isAldeia) {
    showInfoModalConfirm({
      description: props.description,
      onConfirm: props.onConfirm,
      onCancel: props.onCancel,
      okText: props.okText || "Excluir",
      cancelText: props.cancelText,
      title: props.title || "Por favor, confirme",
      zIndex: props.zIndex,
      icon: (
        <span className="fc inline-flex rounded-full bg-[var(--system-red-light)] p-2 outline outline-1 outline-offset-4 outline-red-200 mb-4">
          <IconTypcnWarning className="text-2xl text-white" />
        </span>
      ),
      okButtonProps: {
        style: {
          "--primary": "var(--system-red-light)",
          "--primarySkin": "var(--system-red-light)",
          "--primary-hover": "var(--system-red-light-hover)",
        },
      },
    })
  } else {
    storeJotai.set(modalConfirmAtom, {
      title: props.title || "Por favor, confirme",
      icon: null,
      content: props.description,
      okText: props.okText || "Excluir",
      cancelText: props.cancelText || "Cancelar",
      onOk: props.onConfirm,
      onCancel: props.onCancel,
      cancelButtonProps: {
        type: "text",
      },
      zIndex: props.zIndex,
    })
  }
}

export function showInfoModalConfirm(props: {
  description: string | React.ReactNode
  onConfirm: (...args: any[]) => any
  onCancel?: (...args: any[]) => any
  okText?: string
  cancelText?: string
  title?: string
  zIndex?: number
  icon?: React.ReactNode
  okButtonProps?: any
  cancelButtonProps?: any
}) {
  storeJotai.set(modalConfirmAtom, {
    title: props.title || "Por favor, confirme",
    icon:
      props.icon ||
      (isAldeia ? (
        <span className="fc inline-flex rounded-full bg-primary p-2 outline outline-1 outline-offset-4 outline-primary-light mb-4">
          <IconTypcnWarning className="text-2xl text-white" />
        </span>
      ) : null),
    content: props.description,
    okText: props.okText || "Ok",
    cancelText: props.cancelText || "Cancelar",
    onOk: props.onConfirm,
    okButtonProps: {
      ...props.okButtonProps,
      className: isAldeia ? cn("flex-1 !ml-0 w-full", props.okButtonProps?.className) : undefined,
    },
    cancelButtonProps: {
      type: isAldeia ? undefined : "text",
      // className: isAldeia ? "border-2 border-divider-200 border-solid flex-1 w-full" : undefined,
      className: isAldeia ? "flex-1 w-full" : undefined,
    },
  })
}
